export const parseSessionConfigs = (storedValue) => {
  if (!storedValue) return [];

  try {
    const parsedValue = JSON.parse(storedValue);
    if (Array.isArray(parsedValue)) return parsedValue;
    if (Array.isArray(parsedValue?.data)) return parsedValue.data;
    return [];
  } catch (_error) {
    return [];
  }
};
